import { BUILD_ENVIRONMENTS } from './constants'
import { getBooleanEnvValue, getEnvValue } from './env.utils'

// Default Values must be from production environment

// API
export const API_BFF_ORIGIN = getEnvValue(
  process.env.NEXT_PUBLIC_BFF_DOMAIN,
  'https://api-prod-public.onequince.com/bff-service',
)

export const API_SF_RUNTIME_BASE_URL = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_STORE_FRONT_RUNTIME_API,
  'https://storefront-api.onequince.com/Production',
)

export const API_SF_SAND_PRODUCT_BASE_URL = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_SF_SAND_PRODUCT_ENDPOINT,
  'https://api.onequince.com/sand-product-handler',
)

export const API_SGTM_BASE_URL = getEnvValue(process.env.NEXT_PUBLIC_SGTM_EVENT_API_ENDPOINT, 'https://ia.quince.com')
export const API_SF_BASE_URL = getEnvValue(
  process.env.NEXT_PUBLIC_BASE_SERVICES_URL,
  'https://api-prod-public.quince.com',
  { required: false },
)
export const API_ORDERS_ORIGIN = getEnvValue(
  process.env.NEXT_PUBLIC_ORDERS_API_ENDPOINT,
  'https://ordersapi.onequince.com',
)
export const API_ADDRESS_SERVICE_ORIGNIN = getEnvValue(
  process.env.NEXT_PUBLIC_ADDRESS_SERVICE,
  'https://api.onequince.com',
)

export const API_CUSTOMERS_SEARCH = getEnvValue(
  process.env.NEXT_PUBLIC_CUSTOMERS_SEARCH_API,
  'https://api.onequince.com/customers',
)

export const API_STATE_META_ADDRESS_SERVICE_ORIGNIN = getEnvValue(
  process.env.NEXT_PUBLIC_STATE_META_ADDRESS_SERVICE,
  'https://api-prod-public.quince.com',
)

export const API_OLD_ADDRESS_SERVICE_ORIGNIN = getEnvValue(
  process.env.NEXT_PUBLIC_OLD_ADDRESS_SERVICE,
  'https://api.onequince.com',
)
export const API_LASTBRAND_CUSTOMER_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_LASTBRAND_CUSTOMER_ENDPOINT,
  'https://api.onequince.com/service/customer/',
)
export const API_QUINCE_CUSTOMER_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_CUSTOMER_ENDPOINT,
  'https://api.onequince.com/open/customers/',
)
export const API_LOYALTY_SERVICE_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_LOYALTY_SERVICE,
  'https://api.onequince.com/loyalty-service',
)
export const API_DISCOUNTS_API_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_DISCOUNTS_API_ENDPOINT,
  'https://api.onequince.com/discounts',
)
export const CONFIG_INTERNAL_ANALYTICS_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_INTERNAL_ANALYTICS_URL,
  'https://labg3uadr2.execute-api.us-west-1.amazonaws.com/Production',
)
export const CONFIG_INTERNAL_ANALYTICS_V2_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_INTERNAL_ANALYTICS_V2_URL,
  'https://stream.onequince.com/ia/publish/events',
)
export const CONFIG_REPORTING_SERVICES = getEnvValue(
  process.env.NEXT_PUBLIC_REPORTING_SERVICES,
  'https://api.onequince.com',
)
export const CONFIG_SAND_SERVICES = getEnvValue(
  process.env.NEXT_PUBLIC_SAND_SERVICES,
  'https://api.onequince.com/sand-services',
)
export const CONFIG_LASTBRAND_LIST_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_LASTBRAND_LIST_ENDPOINT,
  'https://8vqpkgfpxc.execute-api.us-west-1.amazonaws.com/Production/',
)
export const CONFIG_PRODUCT_CATALOG_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_PRODUCT_CATALOG_ENDPOINT,
  'https://api.onequince.com',
)
export const CONFIG_PRODUCT_REVIEW_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_PRODUCT_REVIEW_ENDPOINT,
  'https://api.onequince.com/review-system',
)
export const CONFIG_QUINCE_STORE_FRONT_BUILD_API = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_STORE_FRONT_BUILD_API,
  'https://lxnfc3tcg0.execute-api.us-west-1.amazonaws.com/Production',
)
export const CONFIG_QUINCE_SERIVCES_API = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_SERIVCES_API,
  'https://api.onequince.com/service',
)
export const CONFIG_QUINCE_ORDER_AGGREGATOR_SERVICES_API = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_ORDER_AGGREGATOR_SERVICES_API,
  'https://api.onequince.com/order-aggregator-service',
)

export const CONFIG_BUY_NOW_REDIR_DOMAIN = getEnvValue(
  process.env.NEXT_PUBLIC_BUY_NOW_REDIR_DOMAIN,
  'https://www.quince.com',
)

export const CONFIG_QUINCE_RETURN_SERVICE_API = getEnvValue(
  process.env.NEXT_PUBLIC_QUINCE_RETURN_SERVICE_API,
  'https://api.onequince.com/return-management-service/api/v1/external',
)
export const CONFIG_CART_SERVICES = getEnvValue(
  process.env.NEXT_PUBLIC_CART_SERVICES,
  'https://api-prod-public.onequince.com/cart-service',
)

export const CONFIG_CHECKOUT_SERVICES = getEnvValue(
  process.env.NEXT_PUBLIC_CHECKOUT_SERVICES,
  'https://api-prod-public.onequince.com/checkout-service',
)
export const CONFIG_INVENTORY_SERVICES = getEnvValue(
  process.env.NEXT_PUBLIC_INVENTORY_SERVICES,
  'https://api-prod-public.onequince.com/checkout-inventory',
)

export const CONFIG_ADDRESS_VALIDATE_API = getEnvValue(
  process.env.NEXT_PUBLIC_ADDRESS_VALIDATE,
  'https://api.onequince.com/address-service',
)
export const CONFIG_AUTH_ENDPOINT = getEnvValue(process.env.NEXT_PUBLIC_AUTH_DOMAIN, 'auth.onequince.com')
export const CONFIG_STORE_CREDITS_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_STORE_CREDITS_ENDPOINT,
  'https://api.onequince.com/store-credits',
)
export const CONFIG_UPG_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_UPG_BASE_END_POINT,
  'https://api-prod-public.quince.com',
)
// Gladly US Configuration
export const GLADLY_API_URL = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK,
  'https://cdn.gladly.com/help-center/hcl.js',
  { required: false },
)
export const GLADLY_ORG_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK_ORG_ID,
  'Bq5O4FGeR6CHGQtaizG6gA',
  { required: false },
)
export const GLADLY_SDK_URL = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK_HCL,
  'https://quince.us-1.gladly.com',
  { required: false },
)

// Gladly Canada Configuration
export const GLADLY_CA_API_URL = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK_CA,
  'https://quince-ca.us-1.gladly.com',
  { required: false },
)
export const GLADLY_CA_ORG_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK_ORG_ID_CA,
  'arEOWSMpTy6kDR7AFRPLQQ',
  { required: false },
)
export const GLADLY_CA_SDK_URL = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_SDK_HCL_CA,
  'https://cdn.gladly.com/help-center/hcl.js',
  { required: false },
)

export const CONFIG_KEY_GOOGLE_ADS_TRACKING_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GOOGLE_ADS_TRACKING_ID,
  'AW-773421270',
)
export const CONFIG_KEY_GOOGLE_ADS_GA4_TRACKING_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GOOGLE_ADS_GA4_TRACKING_ID,
  'G-Y1VB8K9B1F',
)
export const CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GOOGLE_GTM_WEB_CONTAINER_ID,
  'GTM-5HQ9TQBV',
)
export const CONFIG_TRUSTARC_DOMAIN = getEnvValue(process.env.NEXT_PUBLIC_TRUSTARC_DOMAIN, 'quince.com')

export const CONFIG_B2B_DOMAIN_SUFFIX = getEnvValue(process.env.NEXT_PUBLIC_B2B_DOMAIN_SUFFIX, '.shop.quince.com')

export const CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_URL = getEnvValue(
  process.env.NEXT_PUBLIC_GOOGLE_GTM_SERVER_CONTAINER_URL,
  'https://track.quince.com',
)
export const CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GOOGLE_GTM_SERVER_CONTAINER_ID,
  'G-2B5HWHZPT7',
)

export const SERVER_LOG_LEVEL = getEnvValue(process.env.NEXT_PUBLIC_LOG_LEVEL, 'verbose', {
  required: false,
})

export const CONFIG_KEY_FB_PIXEL_ID = getEnvValue(process.env.NEXT_PUBLIC_FB_PIXEL_ID, '1166796290193151')
export const CONFIG_KEY_FB_CBQ_PIXEL_ID = getEnvValue(process.env.NEXT_PUBLIC_FB_CBQ_PIXEL_ID, '7448080662454722691')
export const CONFIG_MIXPANEL_PROJECT_ID = getEnvValue(
  process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN,
  '4340bb585584c3363ca0f70b0bd6dd60',
)
export const CONFIG_MIXPANEL_PROXY_PROJECT_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GATSBY_MIXPANEL_PROXY_PROJECT_TOKEN,
  '8dc8295d25b9015c759bd4af763cc39c',
)
export const CONFIG_MIXPANEL_PROXY_API_ENDPOINT = getEnvValue(
  process.env.NEXT_PUBLIC_GATSBY_MIXPANEL_PROXY_API_ENDPOINT,
  'https://mixpanel-dev.onequince.com',
)
export const CONFIG_ATTENTIVE_SRC_SCRIPT = getEnvValue(
  process.env.NEXT_PUBLIC_ATTENTIVE_SRC_SCRIPT,
  'https://cdn.attn.tv/quince/dtag.js',
)
export const API_PRESENTATION_LAYER_SERVICE = getEnvValue(
  process.env.NEXT_PUBLIC_PRESENTATION_LAYER_SERVICE,
  'https://api-prod-public.onequince.com/presentation-layer-service',
)
export const API_STORE_PROGRAM_SERVICE = getEnvValue(
  process.env.NEXT_PUBLIC_STORE_PROGRAM_SERVICE,
  'https://api.onequince.com/store-program-service',
)

// Configs
export const CONFIG_BUILD_ENV: BUILD_ENVIRONMENTS = getEnvValue(
  process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT,
  BUILD_ENVIRONMENTS.PROD,
  {
    some: new Set([
      BUILD_ENVIRONMENTS.PROD,
      BUILD_ENVIRONMENTS.STAGE,
      BUILD_ENVIRONMENTS.QA,
      BUILD_ENVIRONMENTS.DEV,
      BUILD_ENVIRONMENTS.AUTO_PREVIEW,
    ]),
    toLower: true,
  },
) as BUILD_ENVIRONMENTS

export const CONFIG_NODE_ENV = getEnvValue(process.env.NODE_ENV, 'production', {
  some: new Set(['production', 'development', 'test']),
})
export const CONFIG_GET_ALL_PRODUCTS_ENV = getEnvValue(process.env.NEXT_PUBLIC_GET_ALL_PRODUCTS_ENV, 'STAGING', {
  required: false,
})
export const CONFIG_ENABLE_HOLIDAY_CUTOFF = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_HOLIDAY_CUTOFF, false, {
  required: false,
})
export const CONFIG_RUNTIME_PDP_REFRESH = getBooleanEnvValue(
  process.env.NEXT_PUBLIC_ENABLE_RUNTIME_PDP_REFRESH,
  false,
  {
    required: false,
  },
)
export const CONFIG_DEBUG_EVENT_LOGGING = getBooleanEnvValue(process.env.NEXT_PUBLIC_DEBUG_EVENT_LOGGING, true)
export const CONFIG_ENABLE_EDD = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_EDD, true)
export const CONFIG_ENABLE_ZIP = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_ZIP, true)

// algolia - only used for events
export const ALGOLIA_INDEX_PRODUCT = getEnvValue(
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_PRODUCT,
  'quince_product_color_index',
)

// Statsig
export const STATSIG_CLIENT_SDK_KEY = getEnvValue(
  process.env.NEXT_PUBLIC_STATSIG_CLIENT_SDK_KEY,
  'client-To78932s8bPfVU5ETJkC9YHBVv1LQnNsktoKWfCdBe1',
)
export const STATSIG_ENV = getEnvValue(process.env.NEXT_PUBLIC_STATSIG_ENV, 'development')

export const CONFIG_ENABLE_GLADLY = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_GLADLY, false, {
  required: false,
})

export const CONFIG_DISABLE_ATTENTIVE = getBooleanEnvValue(process.env.NEXT_PUBLIC_DISABLE_ATTENTIVE, false, {
  required: false,
})

export const CONFIG_GLADLY_HELP_CENTER_CDN = getEnvValue(
  process.env.NEXT_PUBLIC_GLADY_HELP_CENTER_CDN,
  'https://cdn.gladly.com',
  {
    required: false,
  },
)

// Utilities
export const IS_PROD_BUILD = CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.PROD
export const IS_AUTO_PREVIEW_BUILD = CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.AUTO_PREVIEW
export const IS_STAGE_BUILD = CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.STAGE
export const IS_QA_BUILD = CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.QA
export const IS_DEV_BUILD = CONFIG_BUILD_ENV === BUILD_ENVIRONMENTS.DEV

export const IS_PROD_ENV = CONFIG_NODE_ENV === 'production'
export const IS_DEV_ENV = CONFIG_NODE_ENV === 'development'
export const IS_TEST_ENV = CONFIG_NODE_ENV === 'test'

// Helper

// Datadog
export const DD_RUM_APP_ID = getEnvValue(process.env.NEXT_PUBLIC_DD_RUM_APP_ID, '07549463-a070-470e-8cb1-6d02d69a2590')
export const DD_RUM_CLIENT_TOKEN = getEnvValue(
  process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN,
  'pub2ca545ca109e7d9b9d86e373b4458697',
)
export const DD_RUM_ENABLED = getEnvValue(process.env.NEXT_PUBLIC_DD_ENABLED, 'false')
export const DD_RUM_ENABLED_FLAG = !!(DD_RUM_ENABLED === 'true' && DD_RUM_APP_ID && DD_RUM_CLIENT_TOKEN)
export const DD_RUM_ENV = getEnvValue(process.env.NEXT_PUBLIC_DD_RUM_ENV, '')
// @i18n-ignore
export const DD_RUM_SERVICE = 'ecomm-ssr-rum'

export const CONFIG_GLADLY_APP_ID = getEnvValue(process.env.NEXT_PUBLIC_GLADLY_APP_ID, 'quince.com')
export const CONFIG_GLADLY_CORPORATE_GIFTING_APP_ID = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_CORPORATE_GIFTING_APP_ID,
  'quince.com-corporate-gifting',
)
export const ENABLE_I18N = getEnvValue(process.env.NEXT_PUBLIC_ENABLE_I18N, 'false') === 'true'
export const NEXT_PUBLIC_SITE_URL = getEnvValue(process.env.NEXT_PUBLIC_SITE_URL, 'https://www.quince.com/')

export const CONFIG_ENABLE_EDD_ON_CART = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_EDD_ON_CART, true, {
  required: false,
})

export const NEXT_PUBLIC_YOTPO_US_API_KEY = getEnvValue(
  process.env.NEXT_PUBLIC_YOTPO_US_API_KEY,
  'ZbcVKQ8KroJtExhfNREviwtt',
)
export const NEXT_PUBLIC_YOTPO_CA_API_KEY = getEnvValue(
  process.env.NEXT_PUBLIC_YOTPO_CA_API_KEY,
  'wBJcyU8EBHMmdqHMgZ4YvQtt',
)

export const CONFIG_ZIPCODE_SERVICE_API = getEnvValue(
  process.env.NEXT_PUBLIC_ZIPCODE_SERVICE_API,
  'https://fievnbyjld.execute-api.us-west-1.amazonaws.com/prod',
)

export const CONFIG_GLADLY_APP_ID_FOR_CANADA = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_APP_ID_FOR_CANADA,
  'quince.ca',
)

export const CONFIG_GLADLY_CORPORATE_GIFTING_APP_ID_FOR_CANADA = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_CORPORATE_GIFTING_APP_ID_FOR_CANADA,
  'quince.ca-corporate-gifting',
)

export const CONFIG_GLADLY_APP_ID_FOR_CANADA_FR = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_APP_ID_FOR_CANADA_FR,
  'quince.ca-french',
)

export const CONFIG_GLADLY_CORPORATE_GIFTING_APP_ID_FOR_CANADA_FR = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_CORPORATE_GIFTING_APP_ID_FOR_CANADA_FR,
  'quince.ca-french-corporate-gifting',
)

export const CONFIG_GLADLY_BRAND_ID_FOR_CANADA_FR = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_HELP_CENTER_CA_FRENCH,
  'E--DC1taTVWDaqUaeU-a_Q',
)

export const CONFIG_GLADLY_BRAND_ID_FOR_CANADA = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_HELP_CENTER_CA,
  'quince.ca-en-us',
)

export const CONFIG_GLADLY_BRAND_ID_FOR_US = getEnvValue(
  process.env.NEXT_PUBLIC_GLADLY_HELP_CENTER_US,
  'quince.com-en-us',
)

const ENV_INTEG = 'integ'
const ENV_PRE_INTEG = 'pre-integ'
const ENV_PROD = 'prod'
const ENV_STAGE = 'stage'

export const getAnalyticsEnvironment = (): string => {
  const ddEnv = getEnvValue(process.env.DD_ENV, ENV_PROD, { required: false })

  switch (ddEnv) {
    case ENV_INTEG:
      return ENV_INTEG
    case ENV_PRE_INTEG:
      return ENV_PRE_INTEG
    case ENV_PROD:
      return ENV_PROD
    case ENV_STAGE:
      return ENV_STAGE
    default:
      // Default to prod for any unknown environment
      return ENV_PROD
  }
}
export const ENABLE_REPEATABLE_EXP = getEnvValue(process.env.NEXT_PUBLIC_ENABLE_REPEATABLE_EXP, 'true') === 'true'
